<template>
  <div class="StrategyDetails">
    <div class="row justify-content-left align-items-left">
      <div class="col-md-12">
        <br />

        <!-- GOAL DETAIL HEADER -->
        <div v-show="currentDetailType === 'goal'">
          <div class="">
            <div class="offset-2 col-md-8">
              <!-- image commented out -->
            </div>

            <div class="offset-1 col-md-11" style="text-align:left">
              <br />
              <strong>
                {{ $t('crosswalk.goalLabel', { id: (Number(currentGoalId) || 0) + 1 }) }}:
              </strong>
              <!-- Goal description from i18n -->
              {{ $t(`sdgGoals.${(Number(currentGoalId) || 0) + 1}.description`) }}
            </div>
          </div>

          <br />
          <div class="">
            <!-- more info commented out -->
          </div>
          <br />
        </div>

        <div v-if="allStrategyDetails">
          <div v-if="currentDetailType === 'strategy' && allStrategyDetails[currentStrategyId]">
            <div :style="headerStyles(currentStrategyId)">
              {{ allStrategyDetails[currentStrategyId].name }}
            </div>

            <div class="row justify-content-center align-items-center">
              <!-- TARGET IMAGE (only when matrixType === Targets) -->
              <div
                  v-if="
                  matrixType === 'Targets' &&
                  criticalGoalsStore.goals?.[Number(currentGoalId) - 1]?.targets?.[currentTargetId] !== undefined
                "
              >
                <img
                    :src="
                    '/images/GOAL_' +
                    String(Number(currentGoalId)) +
                    '_TARGET_' +
                    criticalGoalsStore.goals[Number(currentGoalId) - 1].targets[currentTargetId].number.toUpperCase() +
                    '.png'
                  "
                    style="height:100px; width:auto; margin-bottom: 10px"
                />
              </div>

              <!-- GOAL IMAGE (all other cases) -->
              <div v-else>
                <img
                    :src="'/images/E-WEB-Goal-' + String(Number(currentGoalId || 0) + 1).padStart(2, '0') + '.png'"
                    style="height:100px; width:auto; margin-bottom: 10px"
                >
              </div>

              <div class="" style="padding-left:20px">
                <!-- TARGET HEADER (matrixType === Targets) -->
                <div
                    v-if="
                    matrixType === 'Targets' &&
                    criticalGoalsStore.goals?.[Number(currentGoalId) - 1]?.targets?.[currentTargetId] !== undefined
                  "
                >
                  <strong>
                    {{ criticalGoalsStore.goals[Number(currentGoalId) - 1].targets[currentTargetId].number }}:
                    {{
                      goalDetailsStore.targetName(
                          goalIdFromTargetNumber(
                              criticalGoalsStore.goals[Number(currentGoalId) - 1].targets[currentTargetId].number
                          ),
                          criticalGoalsStore.goals[Number(currentGoalId) - 1].targets[currentTargetId].number
                      )
                    }}
                  </strong>
                </div>

                <!-- GOAL HEADER (all other cases) -->
                <div v-else>
                  <strong>{{ $t(`sdgGoals.${(Number(currentGoalId) || 0) + 1}.name`) }}</strong>
                </div>

                <br />

                <!-- Assessment radios -->
                <div v-if="matrixType === 'Targets'">
                  <MDBRadio
                      :disabled="!editMode"
                      :label="$t('crosswalk.assessment.yes')"
                      value="crosswalk.assessment.yes"
                      v-model="selectedStrategies[currentStrategyId][currentTargetId]"
                      inline
                      name="inlineRadioOptions"
                  />
                  <MDBRadio
                      :disabled="!editMode"
                      :label="$t('crosswalk.assessment.no')"
                      value="crosswalk.assessment.no"
                      v-model="selectedStrategies[currentStrategyId][currentTargetId]"
                      inline
                      name="inlineRadioOptions"
                  />
                  <MDBRadio
                      :disabled="!editMode"
                      :label="$t('crosswalk.assessment.developing')"
                      value="crosswalk.assessment.developing"
                      v-model="selectedStrategies[currentStrategyId][currentTargetId]"
                      inline
                      name="inlineRadioOptions"
                  />
                  <MDBRadio
                      :disabled="!editMode"
                      :label="$t('crosswalk.assessment.forDiscussion')"
                      value="crosswalk.assessment.forDiscussion"
                      v-model="selectedStrategies[currentStrategyId][currentTargetId]"
                      inline
                      name="inlineRadioOptions"
                  />
                </div>

                <div v-else>
                  <MDBRadio
                      :disabled="!editMode"
                      :label="$t('crosswalk.assessment.yes')"
                      value="crosswalk.assessment.yes"
                      v-model="selectedStrategies[currentStrategyId][currentGoalId]"
                      inline
                      name="inlineRadioOptions"
                  />
                  <MDBRadio
                      :disabled="!editMode"
                      :label="$t('crosswalk.assessment.no')"
                      value="crosswalk.assessment.no"
                      v-model="selectedStrategies[currentStrategyId][currentGoalId]"
                      inline
                      name="inlineRadioOptions"
                  />
                  <MDBRadio
                      :disabled="!editMode"
                      :label="$t('crosswalk.assessment.developing')"
                      value="crosswalk.assessment.developing"
                      v-model="selectedStrategies[currentStrategyId][currentGoalId]"
                      inline
                      name="inlineRadioOptions"
                  />
                  <MDBRadio
                      :disabled="!editMode"
                      :label="$t('crosswalk.assessment.forDiscussion')"
                      value="crosswalk.assessment.forDiscussion"
                      v-model="selectedStrategies[currentStrategyId][currentGoalId]"
                      inline
                      name="inlineRadioOptions"
                  />
                </div>
              </div>
            </div>

            <br />

            <!-- Targets accordion -->
            <div v-if="matrixType !== 'Targets'">
              <MDBAccordion v-model="activeGoalItem" borderless>
                <MDBAccordionItem
                    :headerTitle="$t('crosswalk.targetsHeader')"
                    collapseId="targetAccordion"
                >
                  <!-- allTargetDetails is an ARRAY by goal order => index with (currentGoalId) -->
                  <div
                      v-for="(target, index) in (allTargetDetails?.[Number(currentGoalId)] || [])"
                      :key="target.number"
                  >
                    <div class="row justify-content-center align-items-center">
                      <div class="" style="margin-left:20px">
                        <MDBCheckbox
                            :disabled="!editMode"
                            v-model="selectedTargets[currentGoalId][currentStrategyId][index]"
                            :id="target.number"
                            :label="`${target.number}: ${target.name}`"
                        />
                      </div>
                    </div>

                    <br />
                  </div>
                </MDBAccordionItem>
              </MDBAccordion>
            </div>

            <!-- Sub-strategies accordion -->
            <MDBAccordion v-model="activeGoalItem" borderless>
              <MDBAccordionItem
                  :headerTitle="$t('crosswalk.subStrategiesHeader')"
                  collapseId="targetAccordion"
              >
                <div
                    v-for="(subStrategy, subStrategyIndex) in allStrategyDetails[currentStrategyId].subStrategies"
                    :key="subStrategyIndex"
                    class="row offset-3 col-md-12"
                >
                  <div class="row justify-content-center align-items-center">
                    <div class="" style="margin-left:20px">
                      <div v-if="matrixType === 'Targets'">
                        <MDBCheckbox
                            :disabled="!editMode"
                            v-model="selectedSubstrategies[currentTargetId][currentStrategyId][subStrategyIndex]"
                            :label="subStrategy.name"
                        />
                      </div>
                      <div v-else>
                        <MDBCheckbox
                            :disabled="!editMode"
                            v-model="selectedSubstrategies[currentGoalId][currentStrategyId][subStrategyIndex]"
                            :label="subStrategy.name"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </MDBAccordionItem>
            </MDBAccordion>

            <hr />

            <!-- Notes -->
            <div style="margin-left:20px; margin-right: 20px">
              {{ $t('crosswalk.notesLabel') }}:
              <div
                  v-if="
                  matrixType === 'Targets' &&
                  currentStrategyId !== undefined &&
                  strategyNotes[currentTargetId] !== undefined
                "
              >
                <MDBTextarea
                    :disabled="!editMode"
                    label=""
                    rows="2"
                    v-model="strategyNotes[currentTargetId][currentStrategyId]"
                />
              </div>
              <div
                  v-if="
                  matrixType !== 'Targets' &&
                  currentStrategyId !== undefined &&
                  strategyNotes[currentGoalId] !== undefined
                "
              >
                <MDBTextarea
                    :disabled="!editMode"
                    label=""
                    rows="2"
                    v-model="strategyNotes[currentGoalId][currentStrategyId]"
                />
              </div>
            </div>
          </div>

          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./_StrategyDetails.js" lang="js"></script>
<style src="./_StrategyDetails.less" lang="less"></style>
